const STORAGE_KEY = "seiva_monica_open"
const WIDTH_STORAGE_KEY = "seiva_monica_drawer_width"
const HTML_CLASS = "monica-drawer-open"
const RESIZING_CLASS = "monica-drawer-resizing"
const COMMITTEE_HITL_PRESENT_CLASS = "committee-hitl-present"
const COMMITTEE_HITL_EXPANDED_CLASS = "committee-hitl-expanded"
const COMMITTEE_LAYOUT_CHANGED_EVENT = "seiva:committee-layout-changed"
const DEFAULT_WIDTH = 576
const MIN_WIDTH = DEFAULT_WIDTH * 0.75
const MAX_WIDTH = DEFAULT_WIDTH * 1.5
const MIN_VISIBLE_APP_WIDTH = 320
const COMMITTEE_HITL_COLLAPSED_WIDTH = 64
const COMMITTEE_HITL_EXPANDED_WIDTH = 400

// Reads `data-open` from the drawer root and toggles a class on <html>.
// CSS uses that class to push the main layout left by the drawer's width
// on lg+, so the platform stays usable while the chat is visible on the right.
function syncRootClass(el) {
  const open = el.dataset.open === "true"
  document.documentElement.classList.toggle(HTML_CLASS, open)
}

function committeeHitlWidth() {
  const root = document.documentElement
  if (!root.classList.contains(COMMITTEE_HITL_PRESENT_CLASS)) return 0

  return root.classList.contains(COMMITTEE_HITL_EXPANDED_CLASS)
    ? COMMITTEE_HITL_EXPANDED_WIDTH
    : COMMITTEE_HITL_COLLAPSED_WIDTH
}

function maxAllowedWidth() {
  if (window.innerWidth < 1024) return DEFAULT_WIDTH

  return Math.max(
    MIN_WIDTH,
    Math.min(
      MAX_WIDTH,
      window.innerWidth - MIN_VISIBLE_APP_WIDTH - committeeHitlWidth()
    )
  )
}

function clampWidth(width) {
  return Math.round(Math.min(Math.max(width, MIN_WIDTH), maxAllowedWidth()))
}

function readStoredWidth() {
  const parsed = Number.parseInt(localStorage.getItem(WIDTH_STORAGE_KEY), 10)
  return clampWidth(Number.isFinite(parsed) ? parsed : DEFAULT_WIDTH)
}

function applyDrawerWidth(width) {
  const next = clampWidth(width)
  document.documentElement.style.setProperty("--monica-drawer-width", `${next}px`)
  return next
}

const MatthewDrawer = {
  mounted() {
    syncRootClass(this.el)
    this.drawerWidth = applyDrawerWidth(readStoredWidth())

    this.onPointerMove = event => {
      if (!this.resizing) return
      const delta = this.startX - event.clientX
      this.drawerWidth = applyDrawerWidth(this.startWidth + delta)
    }

    this.stopResize = () => {
      if (!this.resizing) return
      this.resizing = false
      document.body.classList.remove(RESIZING_CLASS)
      window.removeEventListener("pointermove", this.onPointerMove)
      window.removeEventListener("pointerup", this.stopResize)
      window.removeEventListener("pointercancel", this.stopResize)
      localStorage.setItem(WIDTH_STORAGE_KEY, String(this.drawerWidth))
    }

    this.onPointerDown = event => {
      if (window.innerWidth < 1024) return
      event.preventDefault()
      this.resizing = true
      this.startX = event.clientX
      this.startWidth = this.drawerWidth || readStoredWidth()
      document.body.classList.add(RESIZING_CLASS)
      window.addEventListener("pointermove", this.onPointerMove)
      window.addEventListener("pointerup", this.stopResize)
      window.addEventListener("pointercancel", this.stopResize)
    }

    this.onHandleKeydown = event => {
      if (window.innerWidth < 1024) return
      const step = event.shiftKey ? 48 : 24
      const keyMap = {
        ArrowLeft: step,
        ArrowRight: -step,
        Home: MIN_WIDTH - this.drawerWidth,
        End: MAX_WIDTH - this.drawerWidth
      }
      const delta = keyMap[event.key]
      if (delta === undefined) return
      event.preventDefault()
      this.drawerWidth = applyDrawerWidth((this.drawerWidth || readStoredWidth()) + delta)
      localStorage.setItem(WIDTH_STORAGE_KEY, String(this.drawerWidth))
    }

    this.onWindowResize = () => {
      this.drawerWidth = applyDrawerWidth(this.drawerWidth || readStoredWidth())
      localStorage.setItem(WIDTH_STORAGE_KEY, String(this.drawerWidth))
    }

    this.onCommitteeLayoutChanged = () => {
      this.drawerWidth = applyDrawerWidth(this.drawerWidth || readStoredWidth())
    }

    this.bindResizeHandle()
    window.addEventListener("resize", this.onWindowResize)
    window.addEventListener(COMMITTEE_LAYOUT_CHANGED_EVENT, this.onCommitteeLayoutChanged)

    // Sync localStorage whenever the server changes the drawer state
    this.handleEvent("monica:state_changed", ({ open }) => {
      localStorage.setItem(STORAGE_KEY, open ? "true" : "false")
    })
  },
  updated() {
    syncRootClass(this.el)
    this.bindResizeHandle()
  },
  bindResizeHandle() {
    const handle = this.el.querySelector("[data-monica-resize-handle]")
    if (handle === this.resizeHandle) return

    if (this.resizeHandle) {
      this.resizeHandle.removeEventListener("pointerdown", this.onPointerDown)
      this.resizeHandle.removeEventListener("keydown", this.onHandleKeydown)
    }

    this.resizeHandle = handle

    if (this.resizeHandle) {
      this.resizeHandle.addEventListener("pointerdown", this.onPointerDown)
      this.resizeHandle.addEventListener("keydown", this.onHandleKeydown)
    }
  },
  destroyed() {
    document.documentElement.classList.remove(HTML_CLASS)
    document.body.classList.remove(RESIZING_CLASS)
    window.removeEventListener("resize", this.onWindowResize)
    window.removeEventListener(COMMITTEE_LAYOUT_CHANGED_EVENT, this.onCommitteeLayoutChanged)
    window.removeEventListener("pointermove", this.onPointerMove)
    window.removeEventListener("pointerup", this.stopResize)
    window.removeEventListener("pointercancel", this.stopResize)

    if (this.resizeHandle) {
      this.resizeHandle.removeEventListener("pointerdown", this.onPointerDown)
      this.resizeHandle.removeEventListener("keydown", this.onHandleKeydown)
    }
  }
}

export default MatthewDrawer
